import React from 'react'

const Results = ({total}) => {
  return (
    <div> {total && <h1>Your total is: {total}</h1>} </div> 
  )
}

export default Results